export default __webpack_public_path__ + "static/media/Magnifier.70b233c1.svg";